// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"24d59d48","112":"79cb1d86","648":"965bb7f9"}[chunkId] + ".js";
};